import { __assign, __rest } from "tslib";
import React, { useState } from 'react';
import { FlexRow } from "../layout/FlexRow";
import { UserPicture } from './UserPicture';
import { AppHeaderUserInfo } from './AppHeaderUserInfo';
import imgGenericUser from '../../assets/icons/resource-types/User.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { colors } from '../../theme';
import { FlexColumn } from '../layout/FlexColumn';
import { useOutsideClick } from 'outsideclick-react';
var UserMainMenuItem = function (_a) {
    var icon = _a.icon, title = _a.title, style = _a.style, submenu = _a.submenu, action = _a.action, _b = _a.isSectionLabel, isSectionLabel = _b === void 0 ? false : _b;
    var _c = useState(false), submenuOpen = _c[0], setSubmenuOpen = _c[1];
    var _d = useState(false), hover = _d[0], setHover = _d[1];
    return (React.createElement(FlexRow, { width: '100%', justifyContent: 'space-between', alignItems: 'center', style: __assign({ fontWeight: 'initial', paddingBlock: '5px', backgroundColor: hover ? colors.blue[5] : 'white', color: isSectionLabel ? colors.gray[70] : colors.gray[90], cursor: !isSectionLabel ? 'pointer' : 'default', position: 'relative', paddingLeft: '13px', paddingRight: '10px' }, style), onClick: action, onMouseOver: function () {
            setSubmenuOpen(true);
            setHover(true);
        }, onMouseOut: function () {
            setSubmenuOpen(false);
            setHover(false);
        } },
        React.createElement(FlexRow, null,
            icon ?
                React.createElement(FontAwesomeIcon, { icon: icon })
                :
                    null,
            title),
        submenu && submenu.length >= 1 ?
            React.createElement(FontAwesomeIcon, { icon: faCaretRight })
            :
                null,
        submenuOpen && submenu && submenu.length >= 1 ?
            React.createElement(FlexColumn, { width: '200px', rowGap: '10px', style: {
                    alignSelf: 'flex-start',
                    marginBottom: 'initial',
                    position: 'absolute',
                    right: '100%',
                    paddingTop: '8px', paddingBottom: '13px',
                    // paddingLeft: '13px', paddingRight: '10px',
                    border: "1px solid ".concat(colors.gray[20]),
                    backgroundColor: 'white',
                    borderRadius: '4px',
                    fontFamily: 'IBM Plex Sans',
                    fontSize: '14px',
                    color: colors.gray[90]
                } }, submenu.map(function (item, index) {
                return (React.createElement(UserMainMenuItem, { key: index, title: item.title, icon: item.icon, style: item.style, submenu: item.submenu, action: item.action, isSectionLabel: item.isSectionLabel }));
            }))
            :
                null));
};
/** A Navigation bar with a multilevel dynamic dropdown menu. */
export var UserMainMenu = function (_a) {
    var _b = _a.imageSrc, imageSrc = _b === void 0 ? imgGenericUser : _b, _c = _a.userName, userName = _c === void 0 ? '<Unknown User>' : _c, _d = _a.userRole, userRole = _d === void 0 ? '<Unknown Role>' : _d, menuItems = _a.menuItems, style = _a.style, props = __rest(_a, ["imageSrc", "userName", "userRole", "menuItems", "style"]);
    var _e = useState(false), open = _e[0], setOpen = _e[1];
    var handleOutsideClick = function (e) {
        setOpen(false);
    };
    var ref = useOutsideClick(handleOutsideClick);
    return (React.createElement(FlexColumn, { alignItems: 'flex-end', style: __assign({}, style) },
        React.createElement(FlexRow, __assign({ alignItems: 'center', justifyContent: 'flex-end', columnGap: '12px' }, props),
            React.createElement(AppHeaderUserInfo, { userName: userName, userRole: userRole }),
            React.createElement(FlexRow, { alignItems: 'center', columnGap: '8px', style: {
                    cursor: 'pointer'
                }, onClick: function () {
                    setOpen(function (prevState) { return !prevState; });
                } },
                React.createElement(UserPicture, { src: imageSrc, width: 32 }),
                React.createElement(FontAwesomeIcon, { icon: faCaretDown, color: colors.gray[70] }))),
        open && menuItems && menuItems.length >= 1 ?
            React.createElement("div", { ref: ref },
                React.createElement(FlexColumn, { width: '200px', style: {
                        position: 'absolute',
                        top: '40px',
                        right: '0px',
                        paddingTop: '8px', paddingBottom: '13px',
                        // paddingLeft: '13px', paddingRight: '10px',
                        border: "1px solid ".concat(colors.gray[20]),
                        backgroundColor: 'white',
                        borderRadius: '4px',
                        fontFamily: 'IBM Plex Sans',
                        fontSize: '14px',
                        color: colors.gray[90]
                    } }, menuItems.map(function (item, index) {
                    return (React.createElement(UserMainMenuItem, { key: index, title: item.title, icon: item.icon, style: __assign({}, item.style), submenu: item.submenu, action: item.action, isSectionLabel: item.isSectionLabel }));
                })))
            :
                null));
};
